<app-page>
  <app-page-header [ngClass]=AppConfig.theme>
    <app-page-title>{{ title }}</app-page-title>
    <app-page-actions>
      <app-lecture-add-button *appAuthorize="'isInstructor'">
        <button mat-fab
            [ngClass]=AppConfig.theme>
          <mat-icon>add</mat-icon>
        </button>
      </app-lecture-add-button>
    </app-page-actions>
  </app-page-header>
  <app-page-content>
    <app-lecture-nav-list
      [filter]="filter | async"
      [lectures]="service.visibleLectures$">
    </app-lecture-nav-list>
  </app-page-content>
</app-page>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lectures/lectures.component.html